import { render, staticRenderFns } from "./historialPedidos.vue?vue&type=template&id=7d156c32&scoped=true&"
import script from "./historialPedidos.vue?vue&type=script&lang=js&"
export * from "./historialPedidos.vue?vue&type=script&lang=js&"
import style0 from "./historialPedidos.vue?vue&type=style&index=0&id=7d156c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d156c32",
  null
  
)

export default component.exports